import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../utils/metaPixel';
export function ClosingSection() {
  return <section className="w-full bg-navy text-white py-16 md:py-24" data-id="element-26">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-27">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-28">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-gold mb-8" data-id="element-29">
            Dios no te llamó a vivir agotado(a). Te llamó a vivir en paz.
          </h2>

          <div className="prose prose-lg max-w-none mb-8" data-id="element-30">
            <p className="text-white/90 leading-relaxed mb-4 text-lg" data-id="element-31">
              Si llegaste hasta aquí, algo en ti sabe que es momento de dar un
              paso diferente. No un esfuerzo más desde el miedo: un paso desde
              la fe, la gratitud y la obediencia.
            </p>
            <p className="text-white/90 leading-relaxed mb-4 text-lg" data-id="element-32">
              No necesitas más información. Necesitas un sistema simple, bíblico
              y constante que ordene tu interior, fortalezca tu fe y te ayude a
              avanzar con paz real.
            </p>
            <p className="text-gold font-bold text-xl mb-8" data-id="element-33">
              30 días. 10–15 minutos al día. Un paso obediente a la vez.
            </p>
          </div>

          <blockquote className="border-l-4 border-gold pl-6 py-4 mb-12 bg-white/10 rounded-r-lg max-w-2xl mx-auto" data-id="element-34">
            <p className="italic text-xl md:text-2xl font-serif text-gold mb-2" data-id="element-35">
              "Todo lo hizo hermoso en su tiempo."
            </p>
            <cite className="text-white/80 font-semibold not-italic" data-id="element-36">
              Eclesiastés 3:11 (RVR60)
            </cite>
          </blockquote>

          <p className="text-white/90 text-lg mb-8" data-id="element-37">
            Tu tiempo es ahora. Da el primer paso con paz y con fe.
          </p>

          <motion.a id="closing" href="https://pay.hotmart.com/A105236382M" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="bg-gold text-dark font-bold px-12 py-5 rounded-lg text-xl shadow-2xl hover:brightness-110 transition-all inline-block" data-id="element-38">
            Sí, quiero empezar hoy — $6.36 →
          </motion.a>
        </motion.div>
      </div>
    </section>;
}